import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FcGenericItemType,
  FcModifyGenericItemType,
  FindControlDeleteItemResultDto,
  FindControlExportAllDto,
  FindControlExportAllRequestDto,
  FindControlExportItemsDto,
  FindControlExportItemsRequestDto,
  FindControlImportItemsRequestDto,
  FindControlInitDto,
  FindControlResultDto,
  FindControlUserColumnsConfigDto,
  GetDataSearchDto,
  GetMfuSearchDto,
  GetMruSearchDto,
  IColumnPk,
} from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FindControlRepository {
  constructor(private httpClientService: PrmHttpClientService) {}

  routePrefix = 'findcontrol/id';

  exportAll(id: string, exportAllDto: FindControlExportAllRequestDto): Observable<FindControlExportAllDto> {
    const endpointUrl = `${this.routePrefix}/${id}/exportall`;
    const params = new HttpParams().set('IncludeSystemItems', exportAllDto.IncludeSystemItems);
    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

  exportItems(id: string, exportItemsDto: FindControlExportItemsRequestDto): Observable<FindControlExportItemsDto> {
    const endpointUrl = `${this.routePrefix}/${id}/exportitems`;
    return this.httpClientService.sendPostRequest(endpointUrl, exportItemsDto);
  }

  importItems(id: string, importItemsDto: FindControlImportItemsRequestDto): Observable<IColumnPk> {
    const endpointUrl = `${this.routePrefix}/${id}/importitems`;
    return this.httpClientService.sendPostRequest(endpointUrl, importItemsDto);
  }

  getConfig(id: string): Observable<FindControlInitDto> {
    const endpointUrl = `${this.routePrefix}/${id}/initialize`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  getData(id: string, searchDto: GetDataSearchDto): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/search`;
    return this.httpClientService.sendPostRequest(endpointUrl, searchDto);
  }

  getSelectedItems(id: string, guids: string[]): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/selecteditems`;
    return this.httpClientService.sendPostRequest(endpointUrl, guids);
  }

  getItem<T = FcGenericItemType>(id: string, itemPk: string): Observable<T> {
    const endpointUrl = `${this.routePrefix}/${id}/item/${itemPk}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }
  updateItem<T = FcModifyGenericItemType>(id: string, itemPk: string, itemDto: T): Observable<IColumnPk> {
    const endpointUrl = `${this.routePrefix}/${id}/item/${itemPk}`;
    return this.httpClientService.sendPutRequest(endpointUrl, itemDto);
  }
  createItem<T = FcModifyGenericItemType>(id: string, itemDto: T): Observable<IColumnPk> {
    const endpointUrl = `${this.routePrefix}/${id}/item`;
    return this.httpClientService.sendPutRequest(endpointUrl, itemDto);
  }

  getMruList(id: string, maxrows: number, searchDto: GetMruSearchDto): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/mrulist`;
    let params = new HttpParams();
    params = params.set('maxRows', '' + maxrows);
    return this.httpClientService.sendPostRequest(endpointUrl, searchDto, params);
  }

  getMfuList(id: string, maxrows: number, searchDto: GetMfuSearchDto): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/mfulist`;
    let params = new HttpParams();
    params = params.set('maxRows', '' + maxrows);
    return this.httpClientService.sendPostRequest(endpointUrl, searchDto, params);
  }

  updateMfuMruList(id: string, guids: string[]): Observable<string[]> {
    const endpointUrl = `${this.routePrefix}/${id}/updatemfumru`;
    return this.httpClientService.sendPostRequest(endpointUrl, guids);
  }

  deleteItem(id: string, controlId: string): Observable<FindControlDeleteItemResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/delete/${controlId}`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }

  canDeleteItem(id: string, controlId: string): Observable<FindControlDeleteItemResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/can-delete/${controlId}`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }

  mergeItem(id: string, controlId: string, newId: string): Observable<FindControlDeleteItemResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/merge/${controlId}`;
    let params = new HttpParams();
    params = params.set('newId', '' + newId);
    return this.httpClientService.sendDeleteRequest(endpointUrl, params);
  }

  updateUserColumnsConfig(id: string, config: FindControlUserColumnsConfigDto): Observable<FindControlInitDto> {
    const endpointUrl = `${this.routePrefix}/${id}/update-user-columns-config`;
    return this.httpClientService.sendPostRequest(endpointUrl, config);
  }
}
